import React, { useState } from 'react';

import { IServiceData } from 'src/environments/Checkout/interfaces';

import {
  ArrowUpIcon,
  CartIcon,
  ContainerResume,
  ContainerTotal,
  ContainerValues,
  ExpandResumePurchase,
  GrayLine,
  ImageCourse,
  PurchaseCheckout,
} from './style';

import arrowUpIconSVG from '../../../../../../assets/images/subscripiton-checkout-icons/arrow-up-icon.svg';
import cartIconSVG from '../../../../../../assets/images/subscripiton-checkout-icons/cart-icon.svg';

type Props = {
  serviceData: IServiceData;
};

export default function PurchaseResume({ serviceData }: Props): JSX.Element {
  const [expandResume, setExpandResume] = useState(true);

  return (
    <ContainerResume>
      <ExpandResumePurchase
        onClick={() => {
          setExpandResume(!expandResume);
        }}
      >
        <CartIcon src={cartIconSVG} alt="Ícone de carrinho de compras" />
        <p>{expandResume ? 'Ocultar resumo da compra' : 'Exibir resumo da compra'}</p>
        <ArrowUpIcon
          src={arrowUpIconSVG}
          alt="Ícone de seta para cima, indicando ocultar o resumo da compra"
          transform={expandResume ? '' : 'scaleY(-1)'}
        />
      </ExpandResumePurchase>
      <PurchaseCheckout>
        {expandResume && <ImageCourse backImage={serviceData.serviceImage} />}
        {expandResume && <GrayLine />}
        <ContainerTotal>
          <h4>Total</h4>
          <ContainerValues>
            <span>
              {(serviceData.originalPrice / 100).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </span>
            <p>
              {(serviceData.creditPrice / 100).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </p>
          </ContainerValues>
        </ContainerTotal>
      </PurchaseCheckout>
      <GrayLine />
    </ContainerResume>
  );
}
